import { atom } from 'recoil'
import { loadConfig } from '@/utils/userConfig'
import { loadLayout } from '@/utils/layout'

export const userConfigState = atom({
  key: 'UserConfig',
  default: loadConfig()
})

export const layoutState = atom({
  key: 'Layout',
  default: loadLayout()
})
